'use client';

import { setBrowserApiConfig } from '@/lib/api/client/config';
import ThemeProvider from '@/lib/context/ThemeProvider';
import { ConsentProvider } from '@/lib/contexts/consent/ConsentProvider';
import { getConsentProviderConfig } from '@/lib/contexts/consent/utils';
import { SiteBootstrapProvider } from '@/lib/contexts/SiteBootstrapProvider';

import type { SiteConfigResponse } from '@/lib/api';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  config: SiteConfigResponse;
  group: {
    id: string;
    site_name: string;
    tenant_id: string;
  };
  theme: string;
  allowThemeOverride: boolean;
  lang: string;
  apiBaseUrl: string;
  superTokensApiUrl: string;
  tenantId: string;
};

export default function ClientProviders({
  children,
  config,
  group,
  theme,
  allowThemeOverride,
  lang,
  apiBaseUrl,
  superTokensApiUrl,
  tenantId,
}: Props) {
  if (typeof window !== 'undefined') {
    setBrowserApiConfig(apiBaseUrl, superTokensApiUrl, tenantId ?? '');
  }

  const consentConfig = getConsentProviderConfig(group, lang);
  return (
    <SiteBootstrapProvider initialSiteConfig={config}>
      <ConsentProvider {...consentConfig}>
        <ThemeProvider
          defaultTheme={theme}
          allowThemeOverride={allowThemeOverride}
        >
          {children}
        </ThemeProvider>
      </ConsentProvider>
    </SiteBootstrapProvider>
  );
}
